const zh_CN = {
    header: {
        home: '首页',
        create: '创建',
        benefits: '作者福利',
        lang: '语言'
    },
    login: {
        loginbtn: '登录',
        logoutbtn: '注销',
        fblogin: '使用脸书登录',
        googlelogin: '使用谷歌登录'
    },
    footer: {
        lianxi: '联系我们',
        tiaokuan: '使用条款',
        yinsi: '隐私政策',
        xiazai: '下载应用'
    },
    create: {
        size: '封面尺寸：400*560',
        file: '文件格式：.jpg.png',
        upload: '上传',
        title: '小说信息',
        skip: '跳过',
        bookTitle: '书名',
        bookTitlePlace: '在30个字符以内',
        genre: '体裁',
        genrePlace: '请选择体裁',
        editor: '编辑',
        editorPlace: '如果编辑（AE）协助提交您的书籍以供我们审核，请选择其姓名。如果没有，请选择‘无’。',
        contractType: '合同类型',
        targetAudience: '目标受众',
        girl: '女性',
        boy: '男性',
        synopsis: '内容简介',
        description: '请为您的故事撰写20至300字的描述。',
        descriptionInfo: '请不要填写与作品无关的信息。',
        tags: '标签',
        tagsPlace: '请为您的故事至少选择3个标签。',
        tagsTips: '从列表中选择标签（最多5个）。',
        leavinglost: '离开页面后内容如有更改将会丢失！',
        edit: '编辑'
    },
    authorCenter: {
        stories: {
            title: '故事',
            chapters: '章节',
            words: '字数',
            status: '状态',
            newChapters: '新章节',
            noStory: '无故事',
            newStory: '新故事',
            chapterList: '章节列表',
            editStory: '编辑故事',
            secondaryTitle: ['章节列表', '申请合同', '申请完结', '申请奖金', '删除故事'],
            dujia: '独家',
            feidujia: '非独家',
            // 章节页面所有
            noChapter: '无章节',
            Published: '已发布',
            Draft: '草稿',
            // 新建章节
            newChapterPlace: [
                '章节标题。例如：第1章 引言。',
                '每章最少1个字，最多3000个字',
                '请最多输入30个字',
                '作品简介不能少于30个字',
                '请填写您的电子邮箱地址，以便您的书籍通过审核时我们能与您联系。',
                '电子邮件地址无效',
                '您确定要删除该章节吗？'
            ],
            newChapterBtn: ['保存', '发布', '删除'],
            publishChapter: ['自动上传您的章节', '发布计划', '现在', '稍后'],
            confirm: '确认',
            cancel: '取消',
            review: '审核',
            submit: '提交',
            success: '成功',
            submitted: '已提交',
            infoTips: '信息提示',
            // 签约合同
            contractLabel: [
                '您的法定姓名',
                '您的笔名',
                '电子邮件',
                '地址',
                '银行账户类型',
                '收款银行', 
                '环球银行金融电信协会代码（SWIFT）',  // 6
                '收款账号',
                'Whatsapp',
                '身份证正面/护照',
                '国家',
                '分行代码', // 11
                '电话号码',
                '请添加您的区号，例如，+917111111111',
                '银行卡',
                '您的邮政编码',
                '银行地址',
                '银行分行编码', // 17
                '银行邮政编码',
                '是否本币结算',
                '本国货币',
                '美元',
                '身份证反面',
                '银行路由号码',  // 23
                '开户省',
                '开户市',
                '开户支行',
                '银行联行号', // 27
            ],
            contractPlace: [
                '必须填写电子邮件',
                '必须填写收款银行',
                '必须填写地址',
                '必须填写环球银行金融电信协会代码（SWIFT）',
                '必须填写您的法定姓名', // 4
                '必须填写您的笔名',
                '必须填写账户类型',
                '必须填写Whatsapp',
                '必须填写电话号码',
                '必须填写身份证/护照', // 9
                '必须填写账号',
                '必须填写国家',
                '您的合同类型是： ',
                '如果不正确，请点击',
                '此处',
                '以编辑您的合同类型。', // 15
                '必须填写银行地址',
                '必须填写银行分行代码',
                '必须填写银行邮政编码',
                '必须填写您的邮政编码', // 19
                '请选择是否以当地货币结算',
                '必须填写您的银行开户省',
                '必须填写您的银行开户市',
                '必须填写您的银行开户支行',
                '必须填写您的银行联行号', // 24
            ],
            // 申请合同
            applyForContract: [
                '福利 1：专属书籍（已完成和正在进行中）',
                '签约奖金',
                '100 美元（字数 > 10000）',
                '完成奖金',
                '150 美元（60000 - 100000 字）',
                '250 美元（100000 - 130000 字）',
                '350 美元（130000 - 200000 字）',
                '450 美元（>200000 字）',
                '利润分成',
                '注意：',
                '1.对于专属正在进行中的书籍，完成奖金将在书籍完成时添加到您的作者账户中。',
                '福利 2：非专属书籍',
                '50 美元（>50000 字）',
                '1.签约奖金将在您签署合同并上传整本书时添加到您的作者账户中。'
            ],
            contractSign: ['注意', '审核中', '审核合同'],
            // 作品完结
            completing: [
                '每个故事只有一次申请完结的机会。状态更改后，您将无法再发布新章节。您确定要申请完结吗？',
                '您确定要申请完结吗？'
            ],
            // 奖励
            rewards:[
                '结业奖金',
                '字数统计',
                '60k-100k字',
                '100k-130k字',
                '13万至20万字',
                '>20万字',
                '* 奖金仅适用于独家合同。',
            ],
            // 首次发行
            firstRelease: [
                '首次发行奖金：100美元',
                '奖金仅适用于非独家合同',
                '最新章节应该比其他平台早至少5天。',
                '完成的小说应该超过80000字。',
                '作家可以在小说完成后申请奖金。',
            ],
            // 删除
            deleteStory: [
                '只有未发布的故事才能被删除，且删除的故事无法恢复。',
                '您确定要删除这部作品吗？删除后无法恢复。'
            ]
        },
        income: {
            title: '收入',
            Totalincome: '总收入',
            Search: '搜索',
            rules: '提现规则：<br>1. 成为签约作者后，您将开始赚取收益。<br>2. 余额达到100美元时，您将能够提取钱包中的收入。<br>3. 支付产生的税费将由作者根据支付渠道的政策承担。<br>4. 每月只能申请提现一次。<br>5. 您可以在每月的5日至7日（协调世界时/格林威治标准时间+08:00）申请提现。款项将不迟于每月20日（通常为每月15日）发送到您的账户。',
            NoIncome: '无收入',
            withdrawalBtn: ['申请提现', '等待审批', '已批准'],
            withdrawalTable: ['时间', '收入类型']
        },
        inbox: {
            title: '收件箱',
            System: '系统',
            NoInbox: '无收件箱'
        },
        profile: {
            title: '个人资料',
            SAVE: '保存',
            uploadInfo: [
                '请选择要上传的图片',
                '图片不能超过2M'
            ]
        }
    },
    alert: {
        sucAlert: [
            '添加成功！',
            '更新成功！',
            '删除成功！',
            '操作成功！',
            '退出成功！'
        ],
        failAlert: [
            '添加失败！',
            '修改失败！',
            '删除失败！',
            '操作失败！'
        ]
    },
    buyOut: {
        title: '版权买断',
        form: [
            '作者年龄',
            '作者性别',
            '身份证件类型',
            '身份证号码',
            '贝宝（PayPal）',
            '贝宝（PayPal）电子邮件',
            '收款人姓名',
            '印度金融系统代码（IFSC Code）',
            '国际银行账号（IBAN Number）',
            '磁性墨水字符识别码（MICR Code）',
            '监护人全名 ',
            '监护人签名图像'
        ],
        formRules: [
            '填写作者年龄',
            '填写作者性别',
            '请选择身份证件类型',
            '填写身份证号码',
            '填写贝宝（PayPal）电子邮件',
            '填写收款人姓名',
            '填写印度金融系统代码（IFSC Code）',
            '填写国际银行账号（IBAN Number）',
            '填写磁性墨水字符识别码（MICR Code）',
            '填写监护人全名 ',
            '填写监护人签名图像'
        ]
    },
    tips: {
        agreement: '请先同意用户协议和隐私协议！',
        cannotBeEmpty: '邮箱地址不能为空',
        format: '邮箱格式不正确，请检查@符号和域名',
        emailLength: '邮箱长度最多不能超过50个字符',
        inputPassword: '请输入密码',
        passwordLength: '密码长度请输入在8~16位字符之间',
        passwords: '两次输入的密码不一致，请重新确认后输入！',
        registeredSuccessfully: '注册成功！',
        registerFailed: '注册失败！',
    },
};

export default zh_CN;